import React, { useState } from 'react'
import InformationCircle from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/14-Alerts/InformationCircle'
import Disable from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/23-Delete/Disable'
import InstructorProfile from '@classes/InstructorProfile'
import Carousel from '../Carousel'
import AvatarWithName from '../AvatarWithName'
import { InstructorSearchResultInfo } from '@interfaces/Instructor'
import { BlockedIcons, BlockedIconWrapper, BlockIcon, SearchIcon } from './style'
import { useBlockedInstructors } from '../context'
import ProfileModal from '../BulkForm/SelectInstructors/ProfileModal'
import PortalInstructorProfile from '@classes/InstructorProfile'

interface BlockedInstructorsCarouselProps {
  onClickAvatar?: (instructor: InstructorSearchResultInfo) => void
  onClickName?: (instructor: InstructorSearchResultInfo) => void
  onClickIcon?: (instructor: InstructorSearchResultInfo) => void
  isEditMode?: boolean
  isBulkOnlyFeature?: boolean
}

const BlockedInstructorsCarousel: React.FC<BlockedInstructorsCarouselProps> = ({
  onClickAvatar = () => {},
  onClickName = () => {},
  isEditMode,
  isBulkOnlyFeature,
}) => {
  const blocked = useBlockedInstructors()
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedInstructor, setSelectedInstructor] = useState<InstructorSearchResultInfo | undefined>()
  const onClick = (instructor) => {
    setModalOpen(true)
    setSelectedInstructor(instructor)
  }
  const onClickIcon = (instructor: InstructorSearchResultInfo) => {
    if (blocked.isEditMode) {
      blocked.unblockInstructors([instructor])
    } else {
      onClick(instructor)
    }
  }
  return (
    <>
      <Carousel
        items={blocked.blockedInstructors?.map((instructor) => {
          const Profile = new InstructorProfile(instructor)
          return (
            <AvatarWithName
              key={`fave-instructor-${instructor.InstructorId}`}
              image={Profile.Avatar}
              onClickAvatar={() => (isBulkOnlyFeature ? onClick(instructor) : onClickAvatar(instructor))}
              onClickName={() => (isBulkOnlyFeature ? onClick(instructor) : onClickName(instructor))}
              onClickIcon={() => onClickIcon(instructor)}
              name={instructor.Name}
              fave
              isEditMode={blocked.isEditMode}
              customFaveIcon={
                blocked.isEditMode ? undefined : (
                  <BlockedIconWrapper>
                    <BlockedIcons>
                      <SearchIcon>
                        <InformationCircle />
                      </SearchIcon>
                      <BlockIcon>
                        <Disable />
                      </BlockIcon>
                    </BlockedIcons>
                  </BlockedIconWrapper>
                )
              }
            />
          )
        })}
        isEditMode={isEditMode}
        onEditClick={() => {
          blocked.setIsEditMode(!blocked.isEditMode)
        }}
        hideEdit={!blocked.enableActions}
      />

      <ProfileModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        Profile={new PortalInstructorProfile(selectedInstructor)}
      />
    </>
  )
}

export default BlockedInstructorsCarousel
